module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAaCAYAAACQLf2VAAAAFklEQVQoU2N8ysD5nwEJMI4KDI3wAAB9KDItRxArxwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/developerCommunity/dev_red_line.png
// module id = agER
// module chunks = 19